var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{attrs:{"colspan":"2"}},[_c('b-btn',{staticClass:"btn btn-sm btn-akg-dark-green btn-block btn-with-icon-white",attrs:{"variant":"success"},on:{"click":function($event){_vm.create()}}},[_c('i',{staticClass:"fa fa-plus",staticStyle:{"color":"white"},attrs:{"aria-hidden":"true"}}),_vm._v(" KET hozzáadása\n    ")])],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3edfee8e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/CreateKet.vue
// module id = vViD
// module chunks = 0